import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=522f184e&scoped=true"
import script from "./ContactFooter.vue?vue&type=script&lang=js"
export * from "./ContactFooter.vue?vue&type=script&lang=js"
import style0 from "./ContactFooter.vue?vue&type=style&index=0&id=522f184e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f184e",
  null
  
)

export default component.exports